import { Search } from 'lucide-react';
import Input from './Input';
import { Button } from './Button';
import { useState } from 'react';

export default function SurveyFilters({
  searchTerm,
  onSearchChange,
  filter,
  setFilter,
  statuses,
}) {

  return (
    <div className="flex flex-col sm:flex-row gap-3">

      {/* Search */}
      <div className="relative flex-1 max-w-sm">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input value={searchTerm} onChange={(e) => onSearchChange(e.target.value)} placeholder="Rechercher..." className="pl-9" />
      </div>

      {/* Status Filters */}
      <div className="flex gap-2 flex-wrap">
        {statuses.map(f => (
          <Button key={f.key} variant={filter === f.key ? "default" : "outline"} size="sm" onClick={() => setFilter(f.key)}>{f.label}</Button>
        ))}
      </div>

    </div>
  );
}
